import { Color } from '@nect/ui/theme/color';
import { SpacingProp, TextAlign } from '@nect/ui/theme/index';

import HeadlineStyled from './headline.styled';

export interface IHeadlineProps {
    /**
    Color
    */
    color?: Color;

    /**
    Margin
    */
    margin?: SpacingProp;

    /**
    Text content
    */
    children?: string;

    /**
    Text align
    */
    align?: TextAlign;
}

export const HeadlineH1 = HeadlineStyled.HeadlineH1Styled;
export const HeadlineH2 = HeadlineStyled.HeadlineH2Styled;

export const HeadlineH3Bold = HeadlineStyled.HeadlineH3BoldStyled;
export const HeadlineH3Regular = HeadlineStyled.HeadlineH3RegularStyled;

export const HeadlineH4Bold = HeadlineStyled.HeadlineH4BoldStyled;
export const HeadlineH4Regular = HeadlineStyled.HeadlineH4RegularStyled;

export const HeadlineH5Bold = HeadlineStyled.HeadlineH5BoldStyled;
export const HeadlineH5Regular = HeadlineStyled.HeadlineH5RegularStyled;

export const HeadlineH6Bold = HeadlineStyled.HeadlineH6BoldStyled;
export const HeadlineH6Regular = HeadlineStyled.HeadlineH6RegularStyled;

export const HeadlineHeroBold = HeadlineStyled.HeadlineHeroBoldStyled;
export const HeadlineHeroMedium = HeadlineStyled.HeadlineHeroMediumStyled;
export const HeadlineHeroLight = HeadlineStyled.HeadlineHeroLightStyled;

export const HeadlineColossalBold = HeadlineStyled.HeadlineColossalBoldStyled;
export const HeadlineColossalMedium =
    HeadlineStyled.HeadlineColossalMediumStyled;
export const HeadlineColossalLight = HeadlineStyled.HeadlineColossalLightStyled;
